var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoMovies = function SvgIcoMovies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#fff",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.358 2.291c.324-.093.653-.1.962-.035l-1.498 4.35-1.71.49 1.59-4.617zm3.025 3.294-2.388.685 1.227-3.565c.282.245.499.572.61.957zm-4.855-2.77-1.71.491-1.59 4.617 1.71-.49zM9.934 4.134l1.71-.49-1.59 4.617-1.71.49zM5.876 5.297l-1.053.302A2 2 0 0 0 3.45 8.073l.552 1.922.283-.081zm-.416 4.28 1.71-.49L8.76 4.47l-1.71.49zM20 14h-.907l-2.8-4h-1.78l2.8 4h-1.22l-2.8-4h-1.78l2.8 4h-1.22l-2.8-4h-1.78l2.8 4h-1.22l-2.8-4h-1.78l2.8 4h-1.22l-2.8-4H4v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zm0-4h-2.487L20 13.552zm-5.878 8.855a1 1 0 0 0 .001-1.701l-2.597-1.607a1 1 0 0 0-1.526.85v3.209a1 1 0 0 0 1.525.851z",
    clipRule: "evenodd"
  })));
};
export default SvgIcoMovies;